/* GAÏELLE theme JS — vanilla, no dependencies. All core shopping flows work without it (progressive enhancement). */
(function () {
  'use strict';
  var G = window.gaielle || { routes: {}, strings: {} };
  var S = G.strings || {};
  var R = G.routes || {};
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  var safe = function (fn) { return function () { try { return fn.apply(this, arguments); } catch (e) { if (window.console) console.error('[gaielle]', e); } }; };
  
  /* ---------- Panels (drawers / search) ---------- */
  var openPanelEl = null, lastTrigger = null;
  function setInert(panel, on) { if (panel.hasAttribute('data-modal')) { if (on) panel.setAttribute('inert', ''); else panel.removeAttribute('inert'); } }
  function openPanel(panel, trigger) {
    if (!panel) return;
    if (openPanelEl && openPanelEl !== panel) closePanel(openPanelEl, true);
    lastTrigger = trigger || document.activeElement;
    setInert(panel, false);
    panel.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    qsa('[data-panel-open="' + panel.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    openPanelEl = panel;
    setTimeout(function () {
      var f = qs('[data-predictive-input]', panel) || qs(FOCUSABLE, panel.querySelector('.panel__box') || panel);
      (f || panel).focus();
    }, 50);
  }
  function closePanel(panel, silent) {
    if (!panel) return;
    panel.classList.remove('is-open');
    setInert(panel, true);
    document.documentElement.style.overflow = '';
    qsa('[data-panel-open="' + panel.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openPanelEl = null;
    if (!silent && lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  document.addEventListener('click', safe(function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) { e.preventDefault(); openPanel(document.getElementById(opener.getAttribute('data-panel-open')), opener); return; }
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && G.cartType === 'drawer' && document.getElementById('CartDrawer')) { e.preventDefault(); openPanel(document.getElementById('CartDrawer'), toggle); return; }
    var closer = e.target.closest('[data-panel-close]');
    if (closer) { closePanel(closer.closest('[data-panel]')); }
  }));
  document.addEventListener('keydown', safe(function (e) {
    if (!openPanelEl) return;
    if (e.key === 'Escape') { closePanel(openPanelEl); return; }
    if (e.key === 'Tab' && openPanelEl.hasAttribute('data-modal')) {
      var items = qsa(FOCUSABLE, openPanelEl).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }));

  /* ---------- Announcement dismiss ---------- */
  safe(function () {
    var bar = qs('[data-announcement]');
    if (!bar) return;
    var key = 'gaielle-announce-' + (bar.getAttribute('data-key') || '');
    try { if (localStorage.getItem(key) === '1') { bar.hidden = true; return; } } catch (e) {}
    var btn = qs('[data-announcement-close]', bar);
    if (btn) btn.addEventListener('click', function () { bar.hidden = true; try { localStorage.setItem(key, '1'); } catch (e) {} });
  })();

  /* ---------- Auto-submit selects (language, sorting) ---------- */
  document.addEventListener('change', safe(function (e) {
    var t = e.target;
    if (t.matches('[data-auto-submit]')) { t.form.submit(); return; }
    if (t.getAttribute('form') === 'CollectionForm' || t.matches('[data-auto-submit-filter]')) {
      var f = document.getElementById('CollectionForm');
      if (f) { f.requestSubmit ? f.requestSubmit() : f.submit(); }
    }
  }));

  /* ---------- Cart ---------- */
  var cartBusy = false;
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) { var err = new Error(data.description || data.message || S.error); err.data = data; throw err; } return data; });
    });
  }
  function updateCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }
  function swapSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = qs(selector, doc), dest = qs(selector);
    if (src && dest) dest.innerHTML = src.innerHTML;
  }
  function refreshCart() {
    return fetchJSON(R.cartJs, { headers: { Accept: 'application/json' } }).then(function (cart) {
      updateCount(cart.item_count);
      var jobs = [];
      var drawer = document.getElementById('CartDrawer');
      if (drawer) jobs.push(fetch(R.cart + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (h) { swapSection(h, '[data-cart-drawer-content]'); }));
      var page = qs('[data-cart-page]');
      if (page) jobs.push(fetch(R.cart + '?section_id=' + page.getAttribute('data-section-id')).then(function (r) { return r.text(); }).then(function (h) { swapSection(h, '[data-cart-page-content]'); }));
      return Promise.all(jobs).then(function () { return cart; });
    });
  }
  function showCartError(container, msg) {
    var el = qs('[data-cart-error]', container || document) || qs('[data-cart-error]');
    if (!el) return;
    el.textContent = msg; el.hidden = !msg;
  }
  function changeLine(line, quantity, container) {
    if (cartBusy) return;
    cartBusy = true;
    var panel = container && container.closest('[data-panel]');
    if (panel) panel.setAttribute('data-loading', '');
    var restore = document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('data-line');
    fetchJSON(R.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
      .then(refreshCart)
      .then(function () {
        if (restore) { var again = qs('[data-qty-input][data-line="' + restore + '"]'); if (again) again.focus(); }
      })
      .catch(function (err) { showCartError(container, err.message || S.error); refreshCart().catch(function () {}); })
      .then(function () { cartBusy = false; if (panel) panel.removeAttribute('data-loading'); });
  }
  document.addEventListener('click', safe(function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = qs('[data-qty-input][data-line="' + step.getAttribute('data-line') + '"]', step.closest('.cart-item'));
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      changeLine(parseInt(step.getAttribute('data-line'), 10), next, step);
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-line'), 10), 0, rm); }
  }));
  document.addEventListener('change', safe(function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    changeLine(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0), input);
  }));
  document.addEventListener('keydown', safe(function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-qty-input]')) { e.preventDefault(); e.target.dispatchEvent(new Event('change', { bubbles: true })); }
  }));

  /* ---------- Add to cart (product page, cards, bundle) ---------- */
  document.addEventListener('submit', safe(function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || e.defaultPrevented) return;
    var idInput = form.elements.id;
    if (!idInput) return;
    e.preventDefault();
    var btn = qs('[data-add-to-cart]', form);
    var label = qs('[data-add-label]', form);
    var errEl = qs('[data-form-error]', form);
    var status = qs('[data-form-status]', form);
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    var original = label ? label.textContent : '';
    if (btn) btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = S.adding;
    var fd = new FormData();
    fd.append('id', idInput.value);
    fd.append('quantity', (form.elements.quantity && form.elements.quantity.value) || 1);
    qsa('[name^="properties"]', form).forEach(function (p) { fd.append(p.name, p.value); });
    fetchJSON(R.cartAdd, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(refreshCart)
      .then(function () {
        if (label) label.textContent = S.added;
        if (status) status.textContent = S.added;
        setTimeout(function () { if (label) label.textContent = original; }, 1800);
        var drawer = document.getElementById('CartDrawer');
        if (G.cartType === 'drawer' && drawer) openPanel(drawer, btn);
        else if (G.cartType === 'page') window.location.href = R.cart;
      })
      .catch(function (err) {
        if (label) label.textContent = original;
        if (errEl) { errEl.textContent = err.message || S.error; errEl.hidden = false; }
      })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }));

  /* ---------- Product page: gallery, quantity stepper buttons, variants ---------- */
  function initProduct(sec) {
    var slider = qs('[data-gallery-slider]', sec);
    var thumbs = qsa('[data-thumb]', sec);
    var counter = qs('[data-gallery-current]', sec);
    function goTo(mediaId) {
      if (!slider) return;
      var slide = qs('[data-media-id="' + mediaId + '"]', slider);
      if (slide) slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.getAttribute('data-media-id')); }); });
    if (slider) {
      var timer;
      slider.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var i = Math.round(slider.scrollLeft / slider.clientWidth);
          if (counter) counter.textContent = i + 1;
          thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); if (idx === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        }, 80);
      }, { passive: true });
    }

    // Custom Quantity Stepper Buttons Handler (+ / -)
    var quantityInput = qs('[name="quantity"]', sec);
    var quantityButtons = qsa('[data-rp-quantity]', sec);
    var quantityStatus = qs('[data-rp-quantity-status]', sec);

    function syncQuantityButtons() {
      if (!quantityInput) return;
      var minimum = Math.max(1, Number(quantityInput.min) || 1);
      var maximum = quantityInput.max ? Number(quantityInput.max) : Infinity;
      var step = Math.max(1, Number(quantityInput.step) || 1);
      var current = Number(quantityInput.value) || minimum;
      
      quantityButtons.forEach(function (button) {
        var direction = Number(button.getAttribute('data-rp-quantity'));
        button.disabled = direction < 0
          ? current - step < minimum
          : current + step > maximum;
      });
    }

    if (quantityInput && quantityButtons.length) {
      quantityButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var minimum = Math.max(1, Number(quantityInput.min) || 1);
          var maximum = quantityInput.max ? Number(quantityInput.max) : Infinity;
          var step = Math.max(1, Number(quantityInput.step) || 1);
          var current = Number(quantityInput.value) || minimum;
          var direction = Number(button.getAttribute('data-rp-quantity'));
          var next = current + direction * step;

          if (next < minimum || next > maximum) return;
          quantityInput.value = next;
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          if (quantityStatus) quantityStatus.textContent = 'Quantité : ' + next;
          syncQuantityButtons();
        });
      });
      syncQuantityButtons();
    }

    // Legacy fallback stepper (if using data-qty-step-product)
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step-product]');
      if (!b || !quantityInput) return;
      var stepVal = parseInt(b.getAttribute('data-qty-step-product'), 10);
      var currentVal = parseInt(quantityInput.value, 10) || 1;
      var nextVal = Math.max(1, currentVal + stepVal);
      quantityInput.value = nextVal;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      syncQuantityButtons();
    });

    // Variants
    var picker = qs('[data-variant-picker]', sec);
    var vEl = qs('[data-variants-json]', sec);
    if (!picker || !vEl) return;
    var variants = JSON.parse(vEl.textContent);
    var token = 0;
    
    picker.addEventListener('change', safe(function () {
      var selected = qsa('input:checked', picker).sort(function (a, b) { return a.getAttribute('data-position') - b.getAttribute('data-position'); }).map(function (i) { return i.value; });
      var variant = variants.filter(function (v) { return [v.option1, v.option2, v.option3].slice(0, selected.length).every(function (o, i) { return o === selected[i]; }); })[0];
      
      if (!variant) {
        var btn = qs('[data-add-to-cart]', sec);
        if (btn) { btn.disabled = true; qs('[data-add-label]', btn).textContent = S.unavailable; }
        return;
      }
      var idInput = qs('[data-variant-id]', sec);
      if (idInput) idInput.value = variant.id;
      if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u.toString()); }
      if (variant.featured_media && variant.featured_media.id) goTo(variant.featured_media.id);
      
      var my = ++token;
      fetch(sec.getAttribute('data-product-url') + '?variant=' + variant.id + '&section_id=' + sec.getAttribute('data-section-id'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (my !== token) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-price-wrapper]', '[data-buy-wrapper]'].forEach(function (sel) {
            var src = qs(sel, doc), dest = qs(sel, sec);
            if (src && dest) dest.innerHTML = src.innerHTML;
          });
          // Re-bind quantity stepper elements after DOM replacement
          quantityInput = qs('[name="quantity"]', sec);
          quantityButtons = qsa('[data-rp-quantity]', sec);
          syncQuantityButtons();
        })
        .catch(function () {});
    }));
  }
  qsa('[data-product-section]').forEach(safe(initProduct));

  /* ---------- Recommendations ---------- */
  qsa('[data-recommendations]').forEach(safe(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    var run = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = qs('[data-recommendations]', doc);
        if (src && src.innerHTML.trim()) el.innerHTML = src.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); run(); } }, { rootMargin: '300px' });
      io.observe(el);
    } else run();
  }));

  /* ---------- Predictive search ---------- */
  safe(function () {
    var input = qs('[data-predictive-input]');
    var out = qs('[data-predictive-results]');
    if (!input || !out || !R.predictiveSearch) return;
    var timer, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        out.textContent = S.loading;
        fetch(R.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sec = qs('#shopify-section-predictive-search', doc);
            out.innerHTML = sec ? sec.innerHTML : '';
          })
          .catch(function (err) { if (err.name !== 'AbortError') out.textContent = ''; });
      }, 250);
    });
  })();

  /* ---------- Focus message after form post (newsletter / contact) ---------- */
  safe(function () { var el = qs('[data-focus-on-load]'); if (el) setTimeout(function () { el.focus(); }, 100); })();
})();